// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useDataCode() {
  // Hooks
  const api = useApi()

  const refetch = (date: string): Promise<string> => {
    return new Promise<string>((resolve) => {
      api.get(
        "/list_build_item/generate-code",
        { params: { transaction_date: date } }
      ).then((res: SuccessFetch<{
        payload: { next_code: string }
      }>) => {
        resolve(res.data.payload.next_code)
      }).catch(() => {
        resolve("")
      })
    })
  }

  return { refetch }
}